export default __webpack_public_path__ + "static/media/oceania_text.e9c922a4.png";